import PropTypes from "prop-types";
import React, {Component} from "react";
import ButtonBase from '@material-ui/core/ButtonBase';
import { Redirect } from "react-router-dom";
import {Container} from "./Container";
import {di} from "../bottle";
import {Text} from "./Text";
import {exitBRPTV} from "../services/BRPTV";
import pjson from "../../package.json";
import config from "../config/index.js";

// global constants
const en_logo = require("../assets/images/canam-ryker-en-rbg-white.png");
const fr_logo = require("../assets/images/canam-ryker-fr-rbg-white.png");


// class definition
export class Header extends Component {

    static propTypes = {
        style: PropTypes.any,
        onLanguageChange: PropTypes.func,
    };

    static defaultProps = {
        LinkTo: "",
        onLanguageChange: () => undefined
    };

    constructor(props) {
        // call base constructor
        super(props);

        // initialize state
        this.state = {
            resetBike: false,
            selectedLang: null,
            tapCount: 0,
            tapDebounce: null,
        }
    }

    componentDidMount() {
        this.languageSubscription = di.profileManager.lang$.subscribe(lang => {
            this.setState({
                selectedLang: lang
            })
        })
    }

    componentWillUnmount() {
        this.languageSubscription.unsubscribe();
    }

    changeLanguage = lang => {

        // if the current language is the same do nothing
        if (this.state.selectedLang === lang) {
            return;
        }

        // update global language
        di.profileManager.lang = lang;

        // execute callback if defined
        this.props.onLanguageChange();
    };

    onClickInvisibleButton = () => {
        exitBRPTV();
    };

    onClickDebug = () => {
        if (this.state.tapCount + 1 === 3) {
            let load = window.confirm(`Version:${pjson.version}\nLanguages:${di.profileManager.allowedLanguages}\nLanguage:${di.profileManager.lang}\nRegion:${di.profileManager.region}\nPlayerId:${di.profileManager.playerID}\nSketchfabId:${config.sketchfab.id[di.profileManager.region]}\n\nLoad new package?`)
            if (load) {
                let input = document.createElement('input');
                input.type = 'file';
                input.addEventListener('change', (e) => {
                    if (e.target.files[0]) {
                        var reader = new FileReader();
                        reader.onload = async (e) => {
                            // pass the zip file to the asset manager
                            console.log(e);
                            await di.assetManager.loadZipPackage(e.target.result);
                            // reset managers
                            di.catalogManager.initialize();
                            di.modelManager.reinitialize();
                            this.setState({
                                ...this.state,
                                resetBike: true
                            })
                        }
                        reader.readAsArrayBuffer(input.files[0]);
                    }
                  });
                input.click();
            } else {
                di.assetManager.clearZipPackage();
                // reset managers
                di.catalogManager.initialize();
                di.modelManager.reinitialize();
                this.setState({
                    ...this.state,
                    resetBike: true
                })
            }
            clearTimeout(this.state.tapDebounce)
            this.setState({
                ...this.state,
                tapCount: 0,
                tapDebounce: null
            })
            return
        }
        if (this.state.tapDebounce != null) {
            clearTimeout(this.state.tapDebounce)
        }
        const debounce = setTimeout(() => {
            this.setState({
                ...this.state,
                tapCount: 0,
                tapDebounce: null
            })
        }, 1000)
        let locationUrl = new URL(window.location);
        // debug button should not work on prod
        if (locationUrl.host.indexOf("localhost") !== -1 || locationUrl.host.indexOf("staging") !== -1) {
            this.setState({
                ...this.state,
                tapCount: this.state.tapCount + 1,
                tapDebounce: debounce
            })
        }
    }

    renderLanguage = (lang) => {

        let buttonTextStyle;

        if (lang === this.state.selectedLang) {
            buttonTextStyle = {...styles.buttonText, ...styles.buttonSelected}
        } else {
            buttonTextStyle = styles.buttonText;
        }

        return (
            <ButtonBase style={styles.button}
                        onClick={() => this.changeLanguage(lang)}>
                <Text bold style={buttonTextStyle}>
                    {lang.toUpperCase()}
                </Text>
            </ButtonBase>
        )
    };

    render() {

        if (this.state.resetBike) {
            this.setState({
                ...this.state,
                resetBike: false
            })
            return (
              <Redirect
                to={{ pathname: "/selection" }}
              />
            );
          }

        // resolve properties
        const {allowedLanguages} = di.profileManager;
        const {lang} = di.profileManager;

        // initialize languages
        let languages;

        // if there is more than 1 allowed language
        if (allowedLanguages.length > 1) {

            let children = [];

            for (const index in allowedLanguages) {

                children.push(<Container flex direction="row">
                    {/* divider only needed for second and on languages */}
                    {index > 0 && <Container style={styles.divider}/>}

                    {this.renderLanguage(allowedLanguages[index])}
                </Container>)
            }
            languages = <Container style={styles.languageContainer} direction="row">
                            {children}
                        </Container>
        }
        // render view
        return (
            <Container style={styles.header}
                       direction="row"
                       alignItems="center"
                       justify="space-between"
                       alignContent="space-between"
                       aria-hidden="true"
                       tabindex="-1">
                <Container onClick={this.onClickInvisibleButton}>
                    <img style={styles.icon}
                         src={lang === "en" ? en_logo : fr_logo} />
                </Container>
                <Container onClick={this.onClickDebug}>
                    <div style={{width: 50, height: 50}}></div>
                </Container>
                {languages}
            </Container>
        );
    }
}

const styles = {
    header: {
        display: "flex",
        width: "100%",
        height: 90,
        backgroundColor: "#000000"
    },
    icon: {
        marginLeft: 70,
        resizeMode: "contain",
        height: 50
    },
    icon2: {
        marginLeft: 40,
        marginTop: 10,
        width: 113,
        height: 28
    },
    languageContainer: {
        display: "flex",
        marginRight: 20
    },
    button: {
        padding: 15
    },
    buttonSelected: {
        borderBottomWidth: 1,
        borderBottomColor: "#ffd200",
        borderBottomStyle: "solid"
    },
    buttonText: {
        fontSize: 24,
        lineHeight: 1,
        color: "#ffffff"
    },
    divider: {
        marginTop: 7,
        width: 1,
        height: 33,
        border: "solid 1px #979797"
    }
};



// WEBPACK FOOTER //
// ./src/components/Header.js